import { Cuenta, Inversion, Plan } from '../types';
import { ClaveLimite } from '../config/planes';

/**
 * Cuánto lleva gastado un usuario de cada límite del plan gratis
 * (LIMITES_GRATIS en src/config/planes.ts). Funciones puras: las usan tanto
 * los botones de «Nuevo…» como DataContext antes de guardar.
 */

export const cuentasNormales = (cuentas: Cuenta[]) => cuentas.filter(c => c.tipo !== 'hucha').length;
export const huchas = (cuentas: Cuenta[]) => cuentas.filter(c => c.tipo === 'hucha').length;
export const inversionesActivas = (inversiones: Inversion[]) => inversiones.filter(i => i.activo !== false).length;
/** Solo los que organizas y siguen abiertos: a los que te invitan no cuentan. */
export const planesOrganizados = (planes: Plan[], uid: string | undefined) =>
  planes.filter(p => !p.archivado && !!uid && p.organizadoresUids.includes(uid)).length;

/** Límite que gasta una cuenta nueva según su tipo. */
export const limiteDeCuenta = (tipo: Cuenta['tipo']): ClaveLimite => (tipo === 'hucha' ? 'huchas' : 'cuentas');
